import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import NumberAnimation from "./NumberAnimation";
import { useLanguage } from "../i18n/LanguageContext";

export default function Impact() {
  const { t } = useLanguage();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease",
      delay: 100,
    });
  }, []);

  return (
    <div className="impactMain" id="impact">
      <div data-aos="fade-up" className="impactMainInner">
        <h2 className="impactMainHead">
          {t("impact.headBefore")}
          <span className="amg-accent amg-accent--ink">{t("impact.headAccent")}</span>
        </h2>
        <p className="impactMainPara">{t("impact.lead")}</p>
      </div>

      <div data-aos="fade-up" className="impactMainContainer">
        <div className="impactMainChild">
          <p className="impactMainContainerHead">
            <NumberAnimation start={0} end={300} duration={1000} />
          </p>
          <p className="impactMainContainerPara">{t("impact.headcount")}</p>
        </div>
        <div className="impactMainChild">
          <p className="impactMainContainerHead">
            <NumberAnimation start={0} end={20} duration={1000} />
          </p>
          <p className="impactMainContainerPara">{t("impact.contracts")}</p>
        </div>
        <div className="impactMainChild">
          <p className="impactMainContainerHead">
            <NumberAnimation start={0} end={3} duration={1000} />
          </p>
          <p className="impactMainContainerPara">{t("impact.runRate")}</p>
        </div>
        <div className="impactMainChild">
          <p className="impactMainContainerHead">
            <NumberAnimation start={0} end={2} duration={1000} />
          </p>
          <p className="impactMainContainerPara">{t("impact.markets")}</p>
        </div>
      </div>
    </div>
  );
}
